import { Task } from 'app/task/task'
export const taskToPromise = <T>(task: Task<T>, logLabel?: string): Promise<T> =>
  new Promise<T>((resolve, reject) => {
    task.fork(
      error => {
        if (logLabel) {
          console.error(`Error in ${logLabel}:`, error)
        }
        reject(error)
      },
      (success: T) => resolve(success)
    )
  })

export const emptyFunction = () => {
  /*  do nothing  */
}
